/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ISalesLayout } from '../models/ISalesLayout';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class SalesLayoutsService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns ISalesLayout
     * @throws ApiError
     */
    public getSalesLayoutsGetDefault(): CancelablePromise<ISalesLayout> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/sales/layouts/default',
        });
    }

}
